/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import Modal from 'components/Modal';
import icClose from 'static/ic-close.png';
import icInfo from 'static/ic-info-text.png';
import "./ModalRanks.scss"
import bgTop1 from 'static/bg-top1.png'
import bgTop2 from 'static/bg-top2.png';
import bgTop3 from 'static/bg-top3.png';
import icTop1 from 'static/ic-top1.png';
import lightTop1 from 'static/light-top1.png';
import icTop2 from 'static/ic-top2.png';
import icTop3 from 'static/ic-top3.png';
import icCoin from 'static/ic-coin.png';
import icMoney from 'static/ic-money-rank.png';
import bgUserRank from 'static/bg-user-rank.png';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { gameRanking } from 'services';
import { DROP_TITLE, MODAL_TYPE, GAME_CODE_THEME_NEW } from 'helpers/constants';
import unExpected from 'static/un_expected.png';
import { numberFormat } from 'helpers/helpers';
import ModalInfo from './ModalInfo';
import DropBanner from 'components/DropBanner';
import { getGameAsset } from 'helpers/gameAssets';

const Text = styled.p`
    font-family: Titillium Bold, sans-serif;
    margin: 0;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.25rem;
    letter-spacing: 0.5px;
    text-align: center;
`

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8.05px;
    background: rgba(233, 233, 255, 0.2);
    height: 17px;
    box-sizing: border-box;
    gap: 4px;
    padding: 0 8px 0 2px;
    max-width: fit-content;
    white-space: nowrap;
`

const Img = styled.img`
    width: 22px;
    height: 17px;
    flex: 0 0 auto;
    object-fit: contain;
`
const Message = styled.p`
    margin-bottom: 1.875rem;
    white-space: pre-wrap;
    text-align: center;
`

const Loading = styled.div`
    position: unset;
    float: none;
    background: transparent;
    padding-top: 20vh;
`

const Spinner = styled.div`
    border: 3px solid red;
    border-right-color: transparent;
`

const UserBackground = styled.img`
    width: 100%;
    height: 101%;
    position: absolute;
    top: -1px;
    z-index: -1;
`
const ItemTop3 = ({ username, coin, money, moneyIcon, gameCode }) => <div className='w-100 px-2 pt-4'>
    <Text className='user-name' style={{ top: "20.5px", height: "2rem" }}>{username}</Text>
    <div className='row' style={{ top: "3rem" }}>
        {GAME_CODE_THEME_NEW.includes(gameCode) ? <></> : <div className='col p-0 d-flex justify-content-center'>
                <RankInfo src={icCoin} label={coin} />
            </div>
        }
        <div className='col p-0 d-flex justify-content-center'>
            <RankInfo src={moneyIcon} label={numberFormat(money)} />
        </div>
    </div>
</div>

const ItemOther = ({ className, rank, username, coin, money, moneyIcon, gameCode }) => {
    return (
        <div className={`other-item rank-list-item relative ${className || ""}`}>
            <Text className='rank'>{rank}</Text>
            <Text className='user-name'>{username}</Text>
            {GAME_CODE_THEME_NEW.includes(gameCode) ? 
                <div style={{ paddingRight: "3rem"}}>
                        <RankInfo src={moneyIcon} label={numberFormat(money)} />
                </div>: 
                <div className='row'>
                <div className='col p-0 d-flex justify-content-center' >
                    <RankInfo src={icCoin} label={numberFormat(coin)} />
                        </div>
                    
                    <div className='col p-0 d-flex justify-content-center' style={{ paddingRight: "3rem"}}>
                        <RankInfo src={moneyIcon} label={numberFormat(money)} />
                    </div>
                </div>
            }
            {className === "user-rank" && <UserBackground src={bgUserRank} />}
        </div>
    )
}

const RankInfo = ({ className, src, label }) => {
    return (
        <Container className={`rank-info ${className || ""}`}>
            <Img src={src} />
            <Text>{label}</Text>
        </Container>
    )
}


function ModalRank({ isOpen, onCloseModal, gameCode, getGameRanking }) {
    const moneyIcon = getGameAsset(gameCode, 'ic-money-rank', icMoney);
    const [userRanking, setUserRank] = useState({
        rankingOrder: 0,
        customerName: "",
        totalRewardMoney: 0,
        totalRewardCoin: 0
    });
    const [rankingList, setRankList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modal, openModal] = useState(false);
    const getRankInfo = async () => {
        setLoading(true);
        const result = await getGameRanking({ gameCode: gameCode, quantity: 5 });
        // const result = RANK_TEMPLATE;
        setTimeout(() => {
            if (result && result.rankingList && result.userRanking) {
                setRankList(result.rankingList)
                setUserRank(result.userRanking);
            }
            setLoading(false);
        }, 1500);
    }
    useEffect(() => {
        isOpen && getRankInfo();
    }, [isOpen])
    return (
        <div>
            <Modal open={isOpen} onClose={onCloseModal} gameCode={gameCode}>
                <div className="rank-header">
                    <img src={icInfo} style={{ visibility: "hidden", width: "5rem", height: "1.625rem" }} />
                    <img className="icon-header" src={icClose} onClick={() => onCloseModal()} />
                </div>
                {!loading ?
                    <>
                        {rankingList.length > 0 ?
                            <div className='rank-table'>
                                <div className='relative mt-[17.7px]'>
                                    <div className='d-flex justify-content-center'>
                                        <div className='top3'>
                                            <div className='rank2 w-[25%]' style={{ backgroundImage: `url(${bgTop2})` }}>
                                                <img className='iconTop' src={icTop2} />
                                                {rankingList[1] &&
                                                    <ItemTop3 username={rankingList[1].customerName} coin={rankingList[1].totalRewardCoin} money={rankingList[1].totalRewardMoney} moneyIcon={moneyIcon} gameCode={gameCode} />}
                                            </div>
                                            <div className='rank1 w-[30%]' style={{ backgroundImage: `url(${bgTop1})` }}>
                                                <img className='absolute ml-3 top-[-4rem]' style={{ mixBlendMode: "plus-lighter" }} src={lightTop1} />
                                                <img className='iconTop' src={icTop1} />
                                                {rankingList[0] &&
                                                    <ItemTop3 username={rankingList[0].customerName} coin={rankingList[0].totalRewardCoin} money={rankingList[0].totalRewardMoney} moneyIcon={moneyIcon} gameCode={gameCode} />}
                                            </div>
                                            <div className='rank3 w-[25%]' style={{ backgroundImage: `url(${bgTop3})` }}>
                                                <img className='iconTop' src={icTop3} />
                                                {rankingList[2] &&
                                                    <ItemTop3 username={rankingList[2].customerName} coin={rankingList[2].totalRewardCoin} money={rankingList[2].totalRewardMoney} moneyIcon={moneyIcon} gameCode={gameCode} />}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='other'>
                                        <div>
                                            {rankingList[3] && <ItemOther rank={rankingList[3].rankingOrder} username={rankingList[3].customerName} coin={rankingList[3].totalRewardCoin} money={rankingList[3].totalRewardMoney} moneyIcon={moneyIcon} gameCode={gameCode} className={`${userRanking.rankingOrder === 4 ? 'user-rank' : 'rank4'}`} />}
                                            {rankingList[4] && <ItemOther rank={rankingList[4].rankingOrder} username={rankingList[4].customerName} coin={rankingList[4].totalRewardCoin} money={rankingList[4].totalRewardMoney} moneyIcon={moneyIcon} gameCode={gameCode} className={`${userRanking.rankingOrder === 5 ? 'user-rank' : 'rank5'}`} />}
                                            {!!userRanking.rankingOrder && userRanking.rankingOrder > 5 && <ItemOther rank={userRanking.rankingOrder} username={userRanking.customerName} coin={userRanking.totalRewardCoin} money={userRanking.totalRewardMoney} moneyIcon={moneyIcon} gameCode={gameCode} className="user-rank" />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="my-3 mx-5">
                                <img className="align-center" src={unExpected} alt="sad" style={{ mixBlendMode: "luminosity", maxWidth: "40%" }} />
                                <Message>{"Hiện tại không có lịch sử bảng xếp hạng. Bạn vui lòng \nquay trở lại sau"}</Message>
                            </div>
                        }
                    </> :
                    <Loading className="overlay">
                        <Spinner className="spinner" />
                    </Loading>
                }
            </Modal>

            {isOpen && !modal && <DropBanner customClass="drop-top" title={DROP_TITLE[MODAL_TYPE.RANK]} />}
            <ModalInfo
                isOpen={modal === MODAL_TYPE.INFO}
                onCloseModal={() => openModal(null)}
                gameCode={gameCode}
            />
        </div>

    );
}

const mapDispatchToProps = dispatch => ({
    getGameRanking: params => dispatch(gameRanking(params))
});

export default connect(null, mapDispatchToProps)(ModalRank);
